import type { Dictionary } from '@/types'
import { JsonObject, JsonProperty } from 'json2typescript'
import QuoteRequest from './QuoteRequest'

@JsonObject('DynamicQuoteRequest')
export default class DynamicQuoteRequest extends QuoteRequest {
  @JsonProperty('questionAnswers', Object)
  questionAnswers: Dictionary<any | null> = {}
}
